import { ProductInterface } from '../../../services/exports/Interfaces';
import classnames from 'classnames';
import useProductIdentifiers from '../../../hooks/menu/useProductIdentifiers';

interface Props {
  product: ProductInterface;
  className?: string;
}

export default function ProductIdentifiers(props: Props) {
  const { product, className } = props;
  const { names } = useProductIdentifiers(product);

  return (
    product?.identifiers?.length > 0 && (
      <div className={classnames('py-2xs px-xs w-fit rounded-lg bg-gray dark:bg-black', className)}>
        <p className="text-xs text-brand-text-secondary lowercase">{names.implode(' · ')}</p>
      </div>
    )
  );
}
